var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup69(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69",
    "data-name": "Group 69",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#11989a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M7.891,6.083a4.047,4.047,0,1,0,4.047,4.047A4.041,4.041,0,0,0,7.891,6.083Zm0,6.679a2.631,2.631,0,1,1,2.631-2.631,2.636,2.636,0,0,1-2.631,2.631Zm5.157-6.844a.944.944,0,1,1-.944-.944A.942.942,0,0,1,13.048,5.918Zm2.681.958a4.672,4.672,0,0,0-1.275-3.308,4.7,4.7,0,0,0-3.308-1.275c-1.3-.074-5.21-.074-6.513,0A4.7,4.7,0,0,0,1.325,3.565,4.687,4.687,0,0,0,.05,6.872c-.074,1.3-.074,5.21,0,6.513a4.672,4.672,0,0,0,1.275,3.308,4.708,4.708,0,0,0,3.308,1.275c1.3.074,5.21.074,6.513,0a4.672,4.672,0,0,0,3.308-1.275,4.7,4.7,0,0,0,1.275-3.308c.074-1.3.074-5.206,0-6.51Zm-1.684,7.908a2.664,2.664,0,0,1-1.5,1.5c-1.039.412-3.5.317-4.653.317a17.533,17.533,0,0,1-4.653-.317,2.664,2.664,0,0,1-1.5-1.5c-.412-1.039-.317-3.5-.317-4.653a17.533,17.533,0,0,1,.317-4.653,2.664,2.664,0,0,1,1.5-1.5c1.039-.412,3.5-.317,4.653-.317a17.533,17.533,0,0,1,4.653.317,2.664,2.664,0,0,1,1.5,1.5c.412,1.039.317,3.5.317,4.653S14.457,13.748,14.045,14.784Z",
    transform: "translate(8.268 5.659)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup69);
export default __webpack_public_path__ + "static/media/Group 69.0159eced3f5b7a88c5b693809902c4fa.svg";
export { ForwardRef as ReactComponent };